import { Controller } from "@hotwired/stimulus";

// The currency switcher. The choice holds for the whole site, so it goes into the same cookie
// the server reads (site_currency, deliberately not httponly for this reason) and every pricing
// block on the page is told about it. Without JavaScript the form does the same thing through
// the server: it stores the cookie and redirects to the clean URL.
//
// A page can carry more than one switcher (the footer, and a pricing block that has its own),
// so each one marks itself on the shared event rather than only the one that was changed.
export default class extends Controller {
  static targets = ["select", "go"];
  static values = { cookie: { type: String, default: "site_currency" } };

  connect() {
    window.addEventListener("currency:changed", this.onCurrencyChanged);
    // JavaScript is running, so the button that submits the choice without it has no job left.
    if (this.hasGoTarget) this.goTarget.hidden = true;
  }

  disconnect() {
    window.removeEventListener("currency:changed", this.onCurrencyChanged);
    if (this.hasGoTarget) this.goTarget.hidden = false;
  }

  select(event) {
    const code = (this.hasSelectTarget ? this.selectTarget : event.currentTarget).value;
    if (!code) return;

    this.remember(code);

    window.dispatchEvent(new CustomEvent("currency:changed", { detail: { currency: code } }));
  }

  onCurrencyChanged = (event) => {
    if (event.detail && event.detail.currency) this.markCurrent(event.detail.currency);
  };

  remember(code) {
    const secure = window.location.protocol === "https:" ? "; secure" : "";
    document.cookie = `${this.cookieValue}=${encodeURIComponent(code)}; path=/; max-age=31536000; samesite=lax${secure}`;
  }

  markCurrent(code) {
    if (this.hasSelectTarget && this.selectTarget.value !== code) this.selectTarget.value = code;
  }
}
